import { Navigate } from "react-router-dom";

export default function RedirectReviewAttention() {
  return <Navigate to="/dashboard/client/reviews?view=critical" replace />;
}
